import React, { useState } from "react";
import Header from "../../component/header";
import background from "../../asset/images/authBack.png";
import authimg from "../../asset/images/authimg.png";
import "./style.scss";
import { Col, Row } from "antd";
import LoginScreen from "./signIn";
import Signup from "./signUp";
import { Container } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

function AuthenticationScreen() {
  const [authType, setAuthType] = useState("login");
  const navigate = useNavigate();

  const renderContent = () => {
    switch (authType) {
      case "login":
        return <LoginScreen setAuthType={() => setAuthType("register")} />;
      case "register":
        return <Signup setAuthType={() => setAuthType("login")} />;
      default:
        return <LoginScreen setAuthType={() => setAuthType("register")} />;
    }
  };
  return (
    <>
      <Header />
      <div
        style={{
          backgroundImage: `url(${background})`,
        }}
        className="AuthenticationScreen_box1"
      >
        <Container style={{ height: "100%" }}>
          <div
            style={{ cursor: "pointer", width: 40 }}
            onClick={() => navigate("/")}
          >
            <IoIosArrowBack size={32} />
          </div>
          <Row style={{ height: "100%" }}>
            <Col md={15} style={{ height: "100%" }}>
              <div className="AuthenticationScreen_box1_img">
                <img src={authimg} />
              </div>
            </Col>
            <Col md={9} style={{ height: "100%" }}>
              <div className="AuthenticationScreen_box2">{renderContent()}</div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AuthenticationScreen;
